import MainCard from "components/MainCard";
import { Button, Grid, FormHelperText } from "@mui/material";
import { Box } from '@mui/material';
import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { GrView } from "react-icons/gr";
import { FetchAllWhatsappTemplates, FetchPostingChannel, FetchWhatsappChannel, FetchWhatsappTemplateSubIDAgains } from "store/action/index";
import { dispatch } from "store/index";
import { Table, Modal, Spin, Tag, Select, Tooltip, Pagination } from "antd";
import IconButton from "@mui/material/IconButton";
import { EditOutlined } from "@ant-design/icons";
import { IoMdAddCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoIosCall } from "react-icons/io";
import { IoIosLink } from "react-icons/io";
import { MdOutlineRefresh } from "react-icons/md";
import '../../assets/css/custom.css'
import {
  can_add_whatsapp_templates,
  can_view_whatsapp_templates,
} from "helper/permissionsCheck";

const WhatsAppPreviewmodal = (({ preview }) => {
  return (
    <div className="bg-gray-100 p-4 rounded-lg">
      {preview?.headerText && (
        <div className="font-bold text-gray-800 mb-2">
          Character Count: {
            (preview?.headerText?.length || 0) +
            (preview?.text?.length || 0) +
            (preview?.footerText?.length || 0)
          }
        </div>
      )}
      <div className="bg-white rounded-lg shadow-sm p-4 space-y-4">
        {preview?.headerType == "IMAGE" && (
          <div className="flex items-center justify-center bg-gray-200 h-32 w-full rounded">
            <img
              src="https://media.istockphoto.com/id/1324356458/vector/picture-icon-photo-frame-symbol-landscape-sign-photograph-gallery-logo-web-interface-and.jpg?s=612x612&w=0&k=20&c=ZmXO4mSgNDPzDRX-F8OKCfmMqqHpqMV6jiNi00Ye7rE="
              alt="Image Placeholder"
              style={{ width: "100%" }}
            />
          </div>
        )}
        {preview?.headerType == "VIDEO" && (
          <div className="flex items-center justify-center bg-gray-200 h-32 w-full rounded">
            <img
              src="https://raw.githubusercontent.com/gist/pigeonflight/80cb4f51e9bd538b82b3895ad60a38d0/raw/7d4726abfcce7ad4d23763e6a8c942077d603789/video-placeholder.svg"
              alt="Video Placeholder"
              style={{ width: "100%" }}
            />
          </div>
        )}
        {preview?.headerType == "DOCUMENT" && (
          <div className="flex items-center justify-center bg-gray-200 h-32 w-full rounded">
            <img
              src="https://www.shutterstock.com/shutterstock/videos/3444122189/thumb/7.jpg?ip=x480"
              alt="Document Placeholder"
              style={{ width: "100%" }}
            />
          </div>
        )}
        {preview?.headerText && (
          <div className="font-bold text-gray-800 mb-2" style={{ fontWeight: 'bold' }}>{preview?.headerText}</div>
        )}

        {preview?.text && (
          <div className="text-gray-700">
            {preview?.text?.split("\n")?.map((line, index) => (
              <p key={index} className="mb-2">{line}</p>
            ))}
          </div>
        )}


        {preview?.footerText && (
          <div className="text-sm text-gray-500 mt-2" style={{ color: "#060c1070", fontSize: "13px" }}>{preview?.footerText}</div>
        )}

        {Array.isArray(preview?.buttons) && preview?.buttons?.length > 0 && (
          <div className="space-y-2 d-flex flex-column pt-2 border-t">
            {preview?.buttons.map((button) => (
              <Button
                key={button.id}
                className="w-full bg-blue-600 m-1 rounded"
                style={{ backgroundColor: "#cadaf7" }}
              >
                {button.text || `New ${button.type} Button`}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

const WhatsappTemplate = ({ whatsappTemplates, updatedwhatsappTemplate }) => {
  const [loading, setLoading] = useState(true);
  const [loadingSync, setLoadingSync] = useState(false);
  const [error, setError] = useState('');
  const [SubjectIdSt, setSubjeIdSt] = useState('');
  const [params, setparams] = useState({ page: 1, team_id: localStorage.getItem("teams_id") });
  const selector = useSelector((state) => state);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState({
    headerText: '',
    headerType: '',
    text: '',
    footerText: '',
    buttons: []
  });
  const { Option } = Select;
  let paramsss = { team_id: localStorage.getItem("teams_id") }


  const parseTemplateData = (data) => {
    try {
      if (!data?.body) {
        return null;
      }
      return JSON.parse(data.body);
    } catch (error) {
      console.error("Error parsing template data:", error);
      return null;
    }
  };

  const handleOpen = (record) => {
    const decodeData = parseTemplateData(record)
    setPreview((prev) => ({
      ...prev,
      ...(decodeData?.content?.header?.text && { headerText: decodeData?.content?.header?.text }),
      ...(decodeData?.content?.text && { text: decodeData?.content?.text }),
      ...(decodeData?.content?.footer?.text && { footerText: decodeData?.content?.footer?.text }),
      headerType: decodeData?.content?.header?.headerType,
      buttons: decodeData?.content?.keyboard?.rows[0]?.buttons ? decodeData?.content?.keyboard?.rows[0]?.buttons : null
    }));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true)
    dispatch(FetchAllWhatsappTemplates({ setLoading: setLoading, params: params }));
  }, [params]);

  useEffect(() => {
    dispatch(FetchWhatsappChannel({ params: paramsss }))
  }, []);

  const renderButtons = (text) => {
    try {
      const parsedBody = JSON.parse(text);
      if (!parsedBody?.content?.keyboard?.rows) return null;

      return (
        <div className="flex flex-col gap-2">
          {parsedBody.content.keyboard.rows.map((row, rowIndex) => (
            <div key={rowIndex} className="d-flex gap-2">
              {row.buttons.map((button, buttonIndex) => {

                let buttonContent;
                if (button.buttonType === "URL") {
                  buttonContent = (
                    <Tooltip title={button.text + " " + button.url} >  <IoIosLink style={{ fontSize: "22px", cursor: 'pointer' }} />
                    </Tooltip>
                  );
                } else if (button.buttonType === "PHONE") {
                  buttonContent = (
                    <Tooltip title={button.text + " " + button.phone} > <IoIosCall style={{ fontSize: "22px", cursor: 'pointer' }} /></Tooltip>
                  );
                }
                return (
                  <div key={buttonIndex}>
                    {buttonContent}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      );
    } catch (error) {
      console.error("Error parsing buttons:", error);
      return null;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Body",
      dataIndex: "body",
      key: "content",
      render: (text) => {
        try {
          const parsedBody = JSON.parse(text);
          return parsedBody?.content?.text || text;
        } catch (error) {
          return text;
        }
      }
    },
    {
      title: "Category",
      dataIndex: "body",
      key: "content",
      render: (text) => {
        try {
          const parsedBody = JSON.parse(text);
          return parsedBody?.category || "";
        } catch (error) {
          return text;
        }
      }
    },

    {
      title: "Footer",
      dataIndex: "body",
      key: "footer",
      render: (text) => {
        try {
          const parsedBody = JSON.parse(text);
          return parsedBody?.content?.footer?.text;
        } catch (error) {
          return text;
        }
      }
    },
    {
      title: "Status",
      dataIndex: "body",
      key: "status",
      render: (text) => {
        try {
          const parsedBody = JSON.parse(text);
          return <Tag color={parsedBody?.status === 'APPROVED' ? 'green' : parsedBody?.status === 'PENDING' ? 'yellow' : 'red'}>{parsedBody?.status}</Tag>;
        } catch (error) {
          return text;
        }
      }
    },
    {
      title: "Buttons",
      dataIndex: "body",
      key: "buttons",
      render: renderButtons
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => {
        return (
          <Tooltip title="Template Preview">
            <IconButton className="mx-2" type="primary" variant="contained" onClick={() => handleOpen(record)}>
              <GrView />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const HandleNavigate = () => {
    navigate("/templates/create-whatsapp-templates");
  };

  const HandleSyncFetch = () => {
    if (!SubjectIdSt) {
      setError('Please select a channel before syncing');
      return;
    }
    setLoadingSync(true);
    dispatch(FetchPostingChannel({ setLoading: setLoadingSync, SubjectIdSt: SubjectIdSt, params: paramsss }));
  };
  const handleChannelSelect = (channelId) => {
    setError('');
    setSubjeIdSt(channelId);
    let params = { team_id: localStorage.getItem("teams_id") }
    dispatch(FetchWhatsappTemplateSubIDAgains({ setLoading: setLoading, subjecdId: channelId, params }));
  };
  const AllchannelData = selector?.AllWhatsappChannnel?.allwhatsappchannel ?? [];
  // const activeChannels = AllchannelData?.filter(channel => channel.active == 1);
  const activeChannels = Array.isArray(AllchannelData)
    ? AllchannelData.filter(channel => channel.active === 1)
    : [];

  const handlePageChange = (page) => {
    setparams({ ...params, page });
  };

  return (
    <>
      {can_add_whatsapp_templates ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column", // Default for mobile
            justifyContent: "space-between",
            width: "100%",
            height: "auto", // Adjust height for mobile
            borderRadius: "10px",
            marginBottom: "20px",
            padding: "16px",
            backgroundColor: "#fff",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            {/* Title Section */}
            <Grid item xs={12} sm={6}>
              <span
                style={{
                  fontSize: "18px", // Smaller font for mobile
                  fontWeight: "600",
                }}
              >
                All Whatsapp Templates
              </span>
            </Grid>
            {/* Action Section */}
            <Grid
              item
              xs={12}
              sm={6}
              container
              alignItems="center"
              justifyContent={{ xs: "center", sm: "flex-end" }}
              spacing={1}
            >
              {true ? (
                <>
                  <Grid item>
                    {error && (
                      <FormHelperText sx={{ marginRight: "20px" }} error>
                        {error}
                      </FormHelperText>
                    )}
                    <Select
                      placeholder="Select a channel"
                      onChange={handleChannelSelect}
                      className="ant-height"
                      style={{ minWidth: "150px", width: "100%" }}
                      error={!!error}
                      value={SubjectIdSt}
                    >
                      {Array.isArray(activeChannels) && activeChannels.length !== 0 &&
                        activeChannels.map((channel) => (
                          <Option key={channel.id} value={channel.subjectId}>
                            {channel.name}
                          </Option>
                        ))}
                    </Select>

                  </Grid>
                  <Grid item>
                    <Button
                      disableElevation
                      className="px-4"
                      size="medium"
                      onClick={HandleSyncFetch}
                      type="submit"
                      endIcon={<MdOutlineRefresh />}
                      variant="outlined"
                      style={{ width: "100%" }}
                      disabled={loadingSync}
                    >
                      {loadingSync ? 'Syncing...' : 'Sync'}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      disableElevation
                      className="px-2"
                      size="medium"
                      onClick={HandleNavigate}
                      type="submit"
                      style={{ width: "100%" }} // Adjust width for mobile
                    >
                      <span className="mx-2">
                        <IoMdAddCircle color="#FF264C" size={26} />
                      </span>{" "}
                      Add Template
                    </Button>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </Grid>
        </div>
      ) : null}

      {can_view_whatsapp_templates ?
        <MainCard>
          <Spin spinning={loading}>
            <Table
              className="border rounded"
              style={{ marginTop: 25 }}
              dataSource={whatsappTemplates?.data ?? []}
              pagination={false}
              rowKey="id"
              columns={columns}
            />
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <Pagination
                current={whatsappTemplates?.meta?.current_page || 1}
                total={whatsappTemplates?.meta?.total || 0}
                pageSize={whatsappTemplates?.meta?.per_page || 10}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          </Spin>
        </MainCard> : <></>}
      <Modal open={open} onCancel={handleClose} footer={false} title="Template Preview">
        <WhatsAppPreviewmodal
          preview={preview}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    whatsappTemplates: state.WhatsappTemplatesReducer.whatsappTemplates,
    updatedwhatsappTemplate: state.UpdateReducerWhatsappTemplateSUbjid.updatedwhatsappTemplate,
  };
};

export default connect(mapStateToProps)(WhatsappTemplate);